console.log('gclid.js loaded');
document.addEventListener('DOMContentLoaded', function () {
    // --- CONFIGURATION ---
    const paramName = 'gclid';
    const cookieName = 'gclid';
    const fieldIds = [1955, 1956, 1957, 1958, 1965, 1966, 1967, 1979, 1978, 1980, 1981, 2118, 2100, 2091, 2150, 2159, 2470]; // your Formidable field IDs

    // --- UTILITIES ---
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }
    function setCookie(name, value, days = 90) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
    }
    function fillFields(value) {
        fieldIds.forEach(id => {
            const input = document.querySelector(`[name="item_meta[${id}]"]`);
            if (input) {
                input.value = value;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    // --- LOGIC ---
    const params = new URLSearchParams(window.location.search);
    const gclidParam = params.get(paramName);

    if (gclidParam) {
        // Use URL param and store it in cookie
        console.log('gclid parameter found in URL:', gclidParam);
        setCookie(cookieName, gclidParam);
        console.log('gclid cookie set:', getCookie(cookieName));
        fillFields(gclidParam);
        console.log('Form fields filled with gclid from URL parameter.');
    } else {
        // Fallback: use cookie if present
        const gclidCookie = getCookie(cookieName);
        console.log('gclid cookie found:', gclidCookie);
        if (gclidCookie) fillFields(gclidCookie);
        console.log('Form fields filled with gclid from cookie.');
    }
});
